import * as React from "react";
const SvgArrowModal = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 8, viewBox: "0 0 20 8", ...props }, /* @__PURE__ */ React.createElement("path", { id: "Pol\\xEDgono_398", "data-name": "Pol\\xEDgono 398", d: "M10,0,20,8H0Z", fill: "#fff" }));
export default SvgArrowModal;
